import React from "react";
import { formatMarathiDate } from "@/lib/documentUtils";
import { T } from "@/context/MarathiEditContext";

export const AdjournmentApplicationMarathi = React.forwardRef(function AdjournmentApplicationMarathi(
  { data },
  ref,
) {
  const {
    caseNo, courtName, courtPlace, party1Name, party2Name, party1Role, party2Role, date, adjournmentReason,
    advocateAppearingFor, advocateAppearingNumber, advocateName,
  } = data;
  const mrDate = formatMarathiDate(date);
  const appearLabel = advocateAppearingFor
    ? `${advocateAppearingFor}${
        advocateAppearingNumber && String(advocateAppearingNumber).trim()
          ? ` No. ${String(advocateAppearingNumber).trim()}`
          : ""
      }`
    : "";

  return (
    <div ref={ref} className="a4-sheet mr-doc adj-sheet" data-testid="adjournment-mr-doc">
      <div className="memo-case-row">
        <div className="memo-case-spacer" />
        <div className="memo-case-no-right" data-testid="adj-mr-case-no">
          <T source={caseNo} placeholder="___________" />
        </div>
      </div>

      <div className="mr-court-block">
        <h2 className="doc-court-heading mr-court-left">
          मे.&nbsp;<T source={courtName} placeholder="________________________" />
          {courtPlace && String(courtPlace).trim() ? (
            <>,&nbsp;<T source={courtPlace} placeholder="___________" /></>
          ) : null}
        </h2>
        <h3 className="doc-court-at mr-court-right-in-block">यांचे कोर्टात...</h3>
      </div>

      <div className="party-block">
        <div className="pb-row">
          <div className="pb-name"><T source={party1Name} placeholder="____________________" /></div>
          <div className="pb-brace">{"}"}</div>
          <div className="pb-role">
            वादी / अर्जदार
            <br />
            अपीलकर्ता / फिर्यादी
          </div>
        </div>
        <div className="pb-vs-row">
          <div className="pb-vs-inner">विरुद्ध</div>
        </div>
        <div className="pb-row">
          <div className="pb-name"><T source={party2Name} placeholder="____________________" /></div>
          <div className="pb-brace">{"}"}</div>
          <div className="pb-role">
            प्रतिवादी / वि.प.
            <br />
            रिस्पॉन्डंट / आरोपी
          </div>
        </div>
      </div>

      <div className="doc-body mr-body">
        <p className="doc-intro-line">
          यातील&nbsp;<strong><T source={appearLabel} placeholder="प्रतिवादी" /></strong>
          &nbsp;तर्फे विनंती अर्ज की,
        </p>

        {adjournmentReason && adjournmentReason.trim() ? (
          <p style={{ whiteSpace: "pre-wrap" }}>
            <T source={adjournmentReason.trim()} />
          </p>
        ) : (
          <>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;सदरचे काम आजरोजी&nbsp;<T source={advocateAppearingFor} placeholder="प्रतिवादी" />&nbsp;तर्फे वकीलपत्र दाखल करून हजर होत आहे. सदर
              कामातील कागदपत्रे व माहिती अद्याप उपलब्ध न झाले कारणामुळे सदर कामी कैफियत व म्हणणे देणे
              अडचणीचे झाले आहे.
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;सबब वरील कारणांचा विचार होवून सदर कामी माहिती घेवून कैफियत व म्हणणे
              देणेसाठी पुढील एक महिन्याची मुदत मिळावी.
            </p>
          </>
        )}
      </div>

      <div className="adj-foot">
        <div className="adj-foot-left">
          <div><T source={courtPlace} placeholder="____________" /></div>
          <div>ता.&nbsp;{mrDate}</div>
        </div>
        <div className="adj-foot-right">
          <div className="sig-line" aria-hidden="true" />
          <div className="sig-label">
            मे. जा. व्हावे.
            {advocateName ? (
              <>
                <br />
                अ‍ॅड.&nbsp;<strong><T source={advocateName} /></strong>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
});

export default AdjournmentApplicationMarathi;
